// InvitationsModal.js

import React from 'react';
import { Dialog, DialogContent, DialogHeader, DialogTitle } from "../ui/dialog";
import PendingInvites from './PendingInvites';
import { X } from 'lucide-react';

function InvitationsModal({ isOpen, onClose }) {
  return (
    <Dialog open={isOpen} onOpenChange={onClose}>
      <DialogContent className="sm:max-w-lg">
        <DialogHeader className="flex items-center justify-between pb-2">
          <DialogTitle className="text-2xl font-bold">Group Invitations</DialogTitle>
          {/* Remove the duplicate close button here - DialogContent already has a built-in one */}
        </DialogHeader>
        
        <div className="py-4">
          <PendingInvites onClose={onClose} />
        </div>
      </DialogContent>
    </Dialog>
  );
}

export default InvitationsModal;